import { render, staticRenderFns } from "./FormToggle.vue?vue&type=template&id=82d10274&scoped=true&"
import script from "./FormToggle.vue?vue&type=script&lang=tsx&"
export * from "./FormToggle.vue?vue&type=script&lang=tsx&"
import style0 from "./FormToggle.vue?vue&type=style&index=0&id=82d10274&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d10274",
  null
  
)

export default component.exports